import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react'
import { FiSearch, FiX } from 'react-icons/fi'
import { useFormContext } from 'react-hook-form'
import { CustomInputOmni } from '../../../../components/CustomInputOmni'
import { CustomSelectOmni } from '../../../../components/CustomSelectOmni'

export function FilterForm({ onSubmit, onClear, isSubmitting }) {
  const { register, handleSubmit } = useFormContext()

  return (
    <Box as="form" onSubmit={handleSubmit(onSubmit)} mb={4} p={4} borderRadius="8px" bg="#F9F9F9">
      <Flex flexWrap={{ base: 'wrap', md: 'nowrap' }} gap={4} alignItems="flex-end">
        <Box>
          <CustomInputOmni label="Número" placeholder="Número pedido" {...register('numeroPedido')} maxW="210px" />
        </Box>

        <Box>
          <CustomInputOmni label="De" placeholder="dd/mm/aaaa" type="date" {...register('dataInicio')} maxW="210px" />
        </Box>

        <Box>
          <CustomInputOmni label="Até" placeholder="dd/mm/aaaa" type="date" {...register('dataFim')} maxW="210px" />
        </Box>

        <Box>
          <CustomSelectOmni label="Status Pagamento" placeholder="Todos" {...register('statusPagamento')} maxW="210px">
            <option value="Pago">Pago</option>
            <option value="Pendente">Pendente</option>
          </CustomSelectOmni>
        </Box>

        <Flex gap={2}>
          <Button
            type="submit"
            leftIcon={<Icon as={FiSearch} />}
            colorScheme="blue"
            bg="#378BBF"
            fontSize="12px"
            px={6}
            py={2}
            h="40px"
            borderRadius="8px"
            isLoading={isSubmitting}
            loadingText="Buscando..."
          >
            Buscar
          </Button>

          <Button
            type="button"
            leftIcon={<Icon as={FiX} />}
            colorScheme="gray"
            variant="outline"
            fontSize="12px"
            px={6}
            py={2}
            h="40px"
            borderRadius="8px"
            onClick={onClear}
            disabled={isSubmitting}
          >
            Limpar
          </Button>
        </Flex>
      </Flex>
    </Box>
  )
}
